import styled from "styled-components";
import { theme } from "@themes";

export const UserNoticeContainer = styled.div`
  width: 100%;
  height: 100%;
  background-color: ${({ theme }) => theme.status.warningBackground};
  border-radius: 10px;
`;
export const HeaderContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  svg {
    float: right;
    cursor: pointer;
  }
  label {
    font-weight: 600;
    font-size: 1.5rem;
    line-height: 29px;
    color: ${({ theme }) => theme.status.warning};
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 10px;
  p {
    font-weight: 400;
    font-size: 1rem;
    line-height: 22px;
    color: ${({ theme }) => theme.status.warning};
  }
`;
